import { http } from "@/utils/http"

const NewsletterSubscriberFetchApi = {
    list(params = {}) {
        return http.get("/newsletter-subscribers", { params })
    },
}

export default NewsletterSubscriberFetchApi
